 //import { Component, OnInit } from "@angular/core";
//import { FormBuilder, FormGroup, Validators } from "@angular/forms";


import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";


import { ConsignorService } from '../ApplicationServices/ConsignorService';
import { ConsigneeService } from '../ApplicationServices/ConsigneeService';

import { ConsignorElement } from '../models/ConsignorModel';
import { ConsigneeElement } from '../models/ConsigneeModel';

import { SharedService } from '../ApplicationServices/SharedService';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})


export class AddressComponent implements OnInit {

  CK1: boolean = true;

  IP: number = 0; IPS: number = 0;
  alertmsg111: string = null;showalert111: boolean = false;
  alertmsg222: string = null;showalert222: boolean = false;

  billingaddress = [];   shippingaddress = [];
  closeResult: string;
  alertmsg: string = null;
  showAlert1: boolean = false; showAlert2: boolean = false;
  showalert: boolean = false;

   operationstate: number = 0;
   IDS: number = 0;

    newproductData: any;
    countryData:any;
    stateData:any;
    cityData:any;

    ConsigneeForm: FormGroup;
    ConsignorForm: FormGroup;
    AddressSelectionForm: FormGroup;
    AddressSelectionFormConsignee: FormGroup; AddressSelectionFormConsignor: FormGroup;
    submitted = false;
    consignorsubmitted = false;

    adresses = [
      {
        id: 1,
        email: "abc@gmail.com",
        phone: "9804526251",
        postcode: "700055",
        state: "West Bengal",
        address: "73 Sarat Bose Road , PO Naktala Kolkata",
        lastname: "Ray",
        firstname: "Abhik",
        isDefault: true,
      },
      {
        id: 2,
        email: "abasdasdc@gmail.com",
        phone: "9124526251",
        postcode: "700235",
        state: "Bihar",
        address: "73 Sarat Bose Road , PO Naktala Kolkata",
        lastname: "Mukherjee",
        firstname: "Parmit",
        isDefault: false,
      },
    ];

    constructor(

      private formBuilder: FormBuilder,private modalService: NgbModal,
      private cnorService: ConsignorService, private cneeService: ConsigneeService,
      private shareService: SharedService

      ) {


      this.AddressSelectionForm = this.formBuilder.group({
        adresses: [""],
      });

      this.AddressSelectionFormConsignor = this.formBuilder.group({
        billingaddress: [""],
      });

      this.AddressSelectionFormConsignee = this.formBuilder.group({
        shippingaddress: [""],
      });

      this.ConsigneeForm = this.formBuilder.group({

        ConsigneeId:[0, Validators.required],
        State_Id: [2, Validators.required],
        City_Id: [1],
        FullName: ["", Validators.required],
        MobileNumber: ["", Validators.required],
        PinCode: ["", Validators.required],

        FlatHouseNoBuildingCompanyApartment: ["", Validators.required],
        AreaColonyStreetSectorVillage: ["", Validators.required],
        LandMark: ["", Validators.required],
        SetDefault: "NO",


      });
      this.ConsignorForm = this.formBuilder.group({

        ConsignorId:[0, Validators.required],
        State_Id: [2, Validators.required],
        City_Id: [1],
        FullName: ["", Validators.required],
        MobileNumber: ["", Validators.required],
        PinCode: ["", Validators.required],

        FlatHouseNoBuildingCompanyApartment: ["", Validators.required],
        AreaColonyStreetSectorVillage: ["", Validators.required],
        LandMark: ["", Validators.required],
        SetDefault: "NO",
        IsBillShippingAddressSame: "NO",

      });


    }
    active = 1;


    ngOnInit() {

      this.CK1=false;
      this.ConsignorForm.patchValue({IsBillShippingAddressSame:"NO"});

      this.FillBillingAddressData();
      this.FillShippingAddressData();

      this.getNewProductList();
      this.shareService.getAllFillStateByCountryIdData(101)
      .subscribe(
      (datast) => {
      this.stateData = datast;}
      );

      this.shareService.getAllFillCityByStateIdData(0)
      .subscribe(
        (datact) => {
      this.cityData = datact; }
      );

    }


    getNewProductList() {
      this.newproductData = [
        { ViewStateNewProduct: "NO" },
        { ViewStateNewProduct: "YES" },
      ];
    }

    onOptionsSelectedState(value){
      console.log(value);
        this.shareService.getAllFillCityByStateIdData(value)
        .subscribe(
          (datact) => {

            this.cityData = datact;

          }

        );
      }






    get selectedAdress() {
      return this.AddressSelectionFormConsignor.get("billingaddress").value;
      //return this.AddressSelectionFormConsignee.get("shippingaddress").value;
    }

    get selectedAdressShipping() {
      return this.AddressSelectionFormConsignee.get("shippingaddress").value;
    }






    onConsigneeAdd() {


      // this.consignorsubmitted = true;
    //  console.log(this.ConsignorForm.value);

      //call the service here

     if(

      this.ConsigneeForm.value.State_Id=='' ||
      this.ConsigneeForm.value.FullName==''||
      this.ConsigneeForm.value.MobileNumber==''|| this.ConsigneeForm.value.PinCode==''||
      this.ConsigneeForm.value.FlatHouseNoBuildingCompanyApartment==''|| this.ConsigneeForm.value.AreaColonyStreetSectorVillage==''||
      this.ConsigneeForm.value.LandMark=='' ||
      this.ConsigneeForm.value.State_Id==null ||
      this.ConsigneeForm.value.FullName==null||
      this.ConsigneeForm.value.MobileNumber==null|| this.ConsigneeForm.value.PinCode==null||
      this.ConsigneeForm.value.FlatHouseNoBuildingCompanyApartment==null|| this.ConsigneeForm.value.AreaColonyStreetSectorVillage==null||
      this.ConsigneeForm.value.LandMark==null

      )
      {

       this.alertmsg222 = "Required Fields Must Be Filled !!";
       this.showalert222 = true;
       setTimeout(() => {
         this.showalert222 = false;
       }, 2000);

      }else{


        var firstVal = this.ConsigneeForm.value.MobileNumber;
        this.IP=firstVal.length;
        if( this.IP == 10) {
        }
        else{
          this.alertmsg222 = "Mobile Number is not in correct format of 10 digits";
          this.showalert222 = true;
          setTimeout(() => {
            this.showalert222 = false;
          }, 5000);
          return;
        }


        var firstVal1 = this.ConsigneeForm.value.PinCode;
        this.IPS=firstVal1.length;
        if( this.IPS == 6) {
        }
        else{
          this.alertmsg222 = "Pin Code is not in correct format of 6 digits";
          this.showalert222 = true;
          setTimeout(() => {
            this.showalert222 = false;
          }, 5000);
          return;
        }

       var objj = new ConsigneeElement();

       // objj.ConsignorId = 0;

       if( this.operationstate==0){

         objj.ConsigneeId = 0;
         objj.OperationType= "insert";

       }else{

         objj.ConsigneeId = this.IDS;
         objj.OperationType= "update";

       }

       objj.Country_Id =101;
       objj.MobileNumber=this.ConsigneeForm.value.MobileNumber;
       objj.State_Id =this.ConsigneeForm.value.State_Id;
       objj.City_Id =this.ConsigneeForm.value.City_Id;
       objj.FullName =this.ConsigneeForm.value.FullName;
       objj.PinCode =this.ConsigneeForm.value.PinCode;
       objj.FlatHouseNoBuildingCompanyApartment =this.ConsigneeForm.value.FlatHouseNoBuildingCompanyApartment;
       objj.AreaColonyStreetSectorVillage =this.ConsigneeForm.value.AreaColonyStreetSectorVillage;
       objj.LandMark =this.ConsigneeForm.value.LandMark;


       if( this.ConsigneeForm.value.SetDefault=='' || this.ConsigneeForm.value.SetDefault==null ){
         objj.SetDefault =0;
       }
       else  if( this.ConsigneeForm.value.SetDefault=='YES')
       {
         objj.SetDefault =1;
       }
       else{
         objj.SetDefault =0;
       }

       objj.CreatedBy = Number(sessionStorage.getItem("UID"));

       this.cneeService.insertConsigneeData(objj).subscribe((event: any) => {
           if (event && event.length > 0) {
             console.log(event);
             if (event[0].OperationStatus == "Successfully Saved") {

               this.alertmsg = "Shipping Address Saved Successfully !";
               this.showalert = true;
               setTimeout(() => {
                 this.showalert = false;
               }, 3000);

               this.ConsigneeForm.reset();
               this.FillShippingAddressData();
               this.operationstate=0;

             }
             else
             {

               //this.alertmsg = event[0].OperationStatus;

               this.alertmsg = "Shipping Address Updated Successfully !";
               this.showalert = true;
               setTimeout(() => {
                 this.showalert = false;
               }, 3000);

               this.ConsigneeForm.reset();
               this.FillShippingAddressData();
               this.operationstate=0;

             }

           }
         });


      }

    }

    onConsignorAdd() {

        // this.consignorsubmitted = true;
       //  console.log(this.ConsignorForm.value);
      //call the service here

     if(

     this.ConsignorForm.value.State_Id=='' ||
     this.ConsignorForm.value.FullName==''||
     this.ConsignorForm.value.MobileNumber==''|| this.ConsignorForm.value.PinCode==''||
     this.ConsignorForm.value.FlatHouseNoBuildingCompanyApartment==''|| this.ConsignorForm.value.AreaColonyStreetSectorVillage==''||
     this.ConsignorForm.value.LandMark=='' ||
     this.ConsignorForm.value.State_Id==null ||
     this.ConsignorForm.value.FullName==null||
     this.ConsignorForm.value.MobileNumber==null|| this.ConsignorForm.value.PinCode==null||
     this.ConsignorForm.value.FlatHouseNoBuildingCompanyApartment==null|| this.ConsignorForm.value.AreaColonyStreetSectorVillage==null||
     this.ConsignorForm.value.LandMark==null

     )
     {

      this.alertmsg111 = "Required Fields Must Be Filled !!";
      this.showalert111 = true;
      setTimeout(() => {
        this.showalert111 = false;
      }, 2000);

     }else{


      var firstVal = this.ConsignorForm.value.MobileNumber;
      this.IP=firstVal.length;
      if( this.IP == 10) {
      }
      else{
        this.alertmsg111 = "Mobile Number is not in correct format of 10 digits";
        this.showalert111 = true;
        setTimeout(() => {
          this.showalert111 = false;
        }, 5000);
        return;
      }


      var firstVal1 = this.ConsignorForm.value.PinCode;
      this.IPS=firstVal1.length;
      if( this.IPS == 6) {
      }
      else{
        this.alertmsg111 = "Pin Code is not in correct format of 6 digits";
        this.showalert111 = true;
        setTimeout(() => {
          this.showalert111 = false;
        }, 5000);
        return;
      }


      var objj = new ConsignorElement();

      // objj.ConsignorId = 0;

      if( this.operationstate==0){

        objj.ConsignorId = 0;
        objj.OperationType= "insert";

      }else{

        objj.ConsignorId = this.IDS;
        objj.OperationType= "update";

      }

      objj.Country_Id =101;
      objj.MobileNumber=this.ConsignorForm.value.MobileNumber;
      objj.State_Id =this.ConsignorForm.value.State_Id;
      objj.City_Id =this.ConsignorForm.value.City_Id;
      objj.FullName =this.ConsignorForm.value.FullName;
      objj.PinCode =this.ConsignorForm.value.PinCode;
      objj.FlatHouseNoBuildingCompanyApartment =this.ConsignorForm.value.FlatHouseNoBuildingCompanyApartment;
      objj.AreaColonyStreetSectorVillage =this.ConsignorForm.value.AreaColonyStreetSectorVillage;
      objj.LandMark =this.ConsignorForm.value.LandMark;
      objj.IsBillShippingAddressSame =this.ConsignorForm.value.IsBillShippingAddressSame;


      if( this.ConsignorForm.value.SetDefault=='' || this.ConsignorForm.value.SetDefault==null ){
        objj.SetDefault =0;
      }
      else  if( this.ConsignorForm.value.SetDefault=='YES')
      {
        objj.SetDefault =1;
      }
      else{
        objj.SetDefault =0;
      }

      objj.CreatedBy = Number(sessionStorage.getItem("UID"));


      this.cnorService.insertConsignorData(objj).subscribe((event: any) => {
          if (event && event.length > 0) {
            console.log(event);
            if (event[0].OperationStatus == "Successfully Saved") {

              this.alertmsg = "Billing Address Saved Successfully !";
              this.showalert = true;
              setTimeout(() => {
                this.showalert = false;
              }, 3000);

              this.ConsignorForm.reset();
              this.FillBillingAddressData();
              this.operationstate=0;

            }
            else
            {
              //this.alertmsg = event[0].OperationStatus;

              this.alertmsg = "Billing Address Saved Successfully !";
              this.showalert = true;
              setTimeout(() => {
                this.showalert = false;
              }, 3000);
              this.ConsignorForm.reset();
              this.FillBillingAddressData();
              this.operationstate=0;

            }

          }
        });

     }

     this.FillShippingAddressData();

    }

    FillData(){
   
    this.FillShippingAddressData();


    }


    FillBillingAddressData(){
     
        this.cnorService
        .getAllConsignorMasterByUserIdData(parseInt(sessionStorage.getItem("UID")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.billingaddress = event;

              // if (event[0].OperationStatus == "Successfully Saved") {
             //   alert("done");
            // }

          } else {
            this.billingaddress = [];

          }
        });


    }


    FillShippingAddressData(){
      this.cneeService
        .getAllConsigneeMasterByUserIdData(parseInt(sessionStorage.getItem("UID")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.shippingaddress = event;

              // if (event[0].OperationStatus == "Successfully Saved") {
             //   alert("done");
            // }

          } else {
            this.shippingaddress = [];
          }
        });


    }




    get f() {
      return this.ConsigneeForm.controls;
    }

    // convenience getter for easy access to form fields
    get r() {
      return this.ConsignorForm.controls;
    }

    SetDefaultConsignee() {
      console.log(this.AddressSelectionForm.value);
    }
    SetDefaultConsignor() {
      console.log(this.AddressSelectionForm.value);
    }




    editAddressBilling(id){

      this.IDS=id;
      this.operationstate=1;
      var comp = null;
      this.cnorService
        .getAllConsignorMasterByConsignorIdData(id)
        .subscribe((event: any) => {
          if (event.length > 0) {
            comp = event;


            // this.shareService.getAllFillStateByCountryIdData(event.CountryId)
            // .subscribe(
            //  (datast2) => {
            // this.stateData = datast2;}
            //  );

             this.shareService.getAllFillCityByStateIdData(event.StateId)
             .subscribe(
               (datact3) => {
             this.cityData = datact3; }
             );
              // if (event[0].OperationStatus == "Successfully Saved") {
             //   alert("done");
            // }
            this.ConsignorForm.setValue({

              ConsignorId : id,
              //Country_Id :101,
              MobileNumber:event[0].MobileNumber,
              State_Id :event[0].State_Id,
              City_Id :event[0].City_Id,
              FullName :event[0].FullName,
              PinCode :event[0].PinCode,
              FlatHouseNoBuildingCompanyApartment :event[0].FlatHouseNoBuildingCompanyApartment,
              AreaColonyStreetSectorVillage :event[0].AreaColonyStreetSectorVillage,
              LandMark :event[0].LandMark,
              SetDefault : event[0].SetDefault=0? 'NO':'YES' ,
              IsBillShippingAddressSame: "NO",


            });

          }
        });



      // this.ConsignorForm.setValue({

      //   ConsignorId : id,
      //   //Country_Id :101,
      //   MobileNumber:comp.MobileNumber,
      //   State_Id :comp.State_Id,
      //   City_Id :comp.City_Id,
      //   FullName :comp.FullName,
      //   PinCode :comp.PinCode,
      //   FlatHouseNoBuildingCompanyApartment :comp.FlatHouseNoBuildingCompanyApartment,
      //   AreaColonyStreetSectorVillage :comp.AreaColonyStreetSectorVillage,
      //   LandMark :comp.LandMark,
      //   SetDefault : comp.SetDefault=0? 'NO':'YES' ,


      // });


    }


    deleteAddressBilling(id){

      var objj = new ConsignorElement();

        objj.ConsignorId =id;
        objj.OperationType= "delete";
        objj.CreatedBy = Number(sessionStorage.getItem("UID"));


      this.cnorService.insertConsignorData(objj).subscribe((event: any) => {
        if (event && event.length > 0) {
           //console.log(event);
         // if (event[0].OperationStatus == "Successfully Deleted") {

            this.alertmsg = "Deleted !";

            this.ConsignorForm.reset();
            this.FillBillingAddressData();
            this.operationstate=0;

         // }
         // else
          //{
            //this.alertmsg = event[0].OperationStatus;
            this.ConsignorForm.reset();
            this.FillBillingAddressData();
            this.operationstate=0;

          //}
          this.showAlert1 = true;
          setTimeout(() => {
            this.showAlert1 = false;
          }, 3000);
        }
      });

    }





    editAddressShipping(id){

      this.IDS=id;
      this.operationstate=1;
      var comp = null;
      this.cneeService
        .getAllConsigneeMasterByConsigneeIdData(id)
        .subscribe((event: any) => {
          if (event.length > 0) {
            comp = event;

            // this.shareService.getAllFillStateByCountryIdData(event.CountryId)
            // .subscribe(
            //  (datast2) => {
            // this.stateData = datast2;}
            //  );

             this.shareService.getAllFillCityByStateIdData(event.StateId)
             .subscribe(
               (datact3) => {
             this.cityData = datact3; }
             );


              // if (event[0].OperationStatus == "Successfully Saved") {
             //   alert("done");
            // }
            this.ConsigneeForm.setValue({

              ConsigneeId : id,
              //Country_Id :101,
              MobileNumber:event[0].MobileNumber,
              State_Id :event[0].State_Id,
              City_Id :event[0].City_Id,
              FullName :event[0].FullName,
              PinCode :event[0].PinCode,
              FlatHouseNoBuildingCompanyApartment :event[0].FlatHouseNoBuildingCompanyApartment,
              AreaColonyStreetSectorVillage :event[0].AreaColonyStreetSectorVillage,
              LandMark :event[0].LandMark,
              SetDefault : event[0].SetDefault=0? 'NO':'YES' ,


            });

          }
        });



      // this.ConsignorForm.setValue({

      //   ConsignorId : id,
      //   //Country_Id :101,
      //   MobileNumber:comp.MobileNumber,
      //   State_Id :comp.State_Id,
      //   City_Id :comp.City_Id,
      //   FullName :comp.FullName,
      //   PinCode :comp.PinCode,
      //   FlatHouseNoBuildingCompanyApartment :comp.FlatHouseNoBuildingCompanyApartment,
      //   AreaColonyStreetSectorVillage :comp.AreaColonyStreetSectorVillage,
      //   LandMark :comp.LandMark,
      //   SetDefault : comp.SetDefault=0? 'NO':'YES' ,


      // });


    }


    deleteAddressShipping(id){

      var objj = new ConsigneeElement();

        objj.ConsigneeId =id;
        objj.OperationType= "delete";
        objj.CreatedBy = Number(sessionStorage.getItem("UID"));


      this.cneeService.insertConsigneeData(objj).subscribe((event: any) => {
        if (event && event.length > 0) {
           //console.log(event);
         // if (event[0].OperationStatus == "Successfully Deleted") {

            this.alertmsg = "Deleted !";

            this.ConsigneeForm.reset();
            this.FillShippingAddressData();
            this.operationstate=0;

         // }
         // else
          //{
            //this.alertmsg = event[0].OperationStatus;
            this.ConsigneeForm.reset();
            this.FillShippingAddressData();
            this.operationstate=0;

          //}
          this.showAlert1 = true;
          setTimeout(() => {
            this.showAlert1 = false;
          }, 3000);
        }
      });

    }


    oprData(){

    //  href="https://www.youtube.com/watch?v=7GjOOyBoELw&t=2274s"
          //////////////////////////////// 2
         var newWindow = window.open(
           "https://www.youtube.com/watch?v=7GjOOyBoELw&t=2274s",
          "_blank",
          "location=yes,height=570,width=620,scrollbars=yes,status=yes"
       );


            ///////////////////////////////  3
      //      this.Link ="https://link.flexmls.com/1dck32h88z5f,15";
      //     var newWindow = window.open(
      //      this.Link ,
      //     "_blank",
      //    "location=yes,height=570,width=620,scrollbars=yes,status=yes"
      // );


      ////////////////////////////////// 4
     //var newWindow = window.open("http://localhost:4200/#/admin/productUnit");




    }




}
